import { render } from "./OrderHeader.vue?vue&type=template&id=4e762ced&scoped=true"
import script from "./OrderHeader.vue?vue&type=script&lang=js"
export * from "./OrderHeader.vue?vue&type=script&lang=js"

import "./OrderHeader.vue?vue&type=style&index=0&id=4e762ced&scoped=true&lang=css"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e762ced"]])

export default __exports__